/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './admin-footer.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '@angular/core/src/linker/view_utils';
import * as import5 from '@angular/core/src/di/injector';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/change_detection';
import * as import8 from '@angular/core/src/metadata/view';
import * as import9 from '@angular/core/src/linker/component_factory';
export class Wrapper_AdminFooterComponent {
  context:import0.AdminFooterComponent;
  changed:boolean;
  constructor() {
    this.changed = false;
    this.context = new import0.AdminFooterComponent();
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_AdminFooterComponent_Host:import2.RenderComponentType = (null as any);
class _View_AdminFooterComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _AdminFooterComponent_0_4:Wrapper_AdminFooterComponent;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_AdminFooterComponent_Host0,renderType_AdminFooterComponent_Host,import6.ViewType.HOST,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer,'admin-footer',import4.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_AdminFooterComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._AdminFooterComponent_0_4 = new Wrapper_AdminFooterComponent();
    this._appEl_0.initComponent(this._AdminFooterComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._AdminFooterComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.AdminFooterComponent) && (0 === requestNodeIndex))) { return this._AdminFooterComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._AdminFooterComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._AdminFooterComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_AdminFooterComponent_Host0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_AdminFooterComponent_Host === (null as any))) { (renderType_AdminFooterComponent_Host = viewUtils.createRenderComponentType('',0,import8.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_AdminFooterComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const AdminFooterComponentNgFactory:import9.ComponentFactory<import0.AdminFooterComponent> = new import9.ComponentFactory<import0.AdminFooterComponent>('admin-footer',viewFactory_AdminFooterComponent_Host0,import0.AdminFooterComponent);
const styles_AdminFooterComponent:any[] = ([] as any[]);
var renderType_AdminFooterComponent:import2.RenderComponentType = (null as any);
class _View_AdminFooterComponent0 extends import1.AppView<import0.AdminFooterComponent> {
  _text_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_AdminFooterComponent0,renderType_AdminFooterComponent,import6.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._text_0 = this.renderer.createText(parentRenderNode,'      ',(null as any));
    this._text_1 = this.renderer.createText(parentRenderNode,'\n      ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,parentRenderNode,'footer',new import4.InlineArray2(2,'class','main-footer'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._text_4 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_5 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','pull-right hidden-xs'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'\n        ',(null as any));
    this._text_7 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._text_8 = this.renderer.createText(this._el_2,'\n        © 2017 ',(null as any));
    this._el_9 = import4.createRenderElement(this.renderer,this._el_2,'a',new import4.InlineArray4(4,'href','http://www.forgottenrecords.com','target','_blank'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'Forgotten Records',(null as any));
    this._text_11 = this.renderer.createText(this._el_2,'. Tous droits réservés.\n      ',(null as any));
    this.init(([] as any[]),[
      this._text_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
}
export function viewFactory_AdminFooterComponent0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<import0.AdminFooterComponent> {
  if ((renderType_AdminFooterComponent === (null as any))) { (renderType_AdminFooterComponent = viewUtils.createRenderComponentType('',0,import8.ViewEncapsulation.None,styles_AdminFooterComponent,{})); }
  return new _View_AdminFooterComponent0(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/admin-footer.component.ngfactory.ts